/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".data[_ngcontent-%COMP%]{display:block;width:75vw;overflow:auto}.data[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%]{width:90vw;max-width:100%;overflow:auto;display:table;border-collapse:collapse;margin:0}.cCell[_ngcontent-%COMP%]{padding:0 .5vh}"];
export { styles as styles };
